<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    props: {
        prop_edit: { default: true }
    },
    components: {
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            send: false,
            load: false,
            form: {
                id: '',
                building_id: '',
                user_id: '',
                billing_data_id: '',
                company_id: '',
                start_date: '',
                end_date: '',
                payment_period_id: '',
                currency_id: '',
                bank_account_id: '',
                forced_end_date: '',
                signed: false,
                grace_days: '',
                observations: '',
                drive: '',
                addendum: 0,
                contract_id: '',
                renew_contract_id: '',

                // SOLO SERVICIOS
                services: [],
                obligation: [{ "title": "USO DEL INMUEBLE", "rules": "CASA HABITACI\u00d3N" }, { "title": "FECHA DE PAGO ", "rules": "PRIMERO DIEZ DIAS DE CADA MES" }, { "title": "SERVICIOS", "rules": "ARRENDATARIA ES LA RESPONSABLE DEL PAGO, INSTALACI\u00d3N, CANCELACI\u00d3N Y MANTENIMIENTO DE TODOS LOS SERVICIOS PUBLICOS Y PRIVADOS QUE SEAN SUMISTRADOS EN EL INMUEBLE TALES COMO AGUA, ENERGIA ELECTRICA, GAS, TELEFONO, E INTERNET, SERVICIOS DE CABLE ENTRE OTROS." }, { "title": "ESTACIONAMIENTO", "rules": "2 LUGARES DE ESTACIONAMIENTO" }, { "title": "MEJORAS", "rules": "PREVIA AUTORIZACI\u00d3N POR PARTE DEL ARRENDADOR QUEDANDO AL TERMINO DEL CONTRATO EN BENEFICIO DEL ARRENDADOR, PODR\u00c1N SER RETIRADAS AQUELLAS QUE SEAN DE FACIL DESPRENDIMIENTO" }, { "title": "SUBARRENDAMIENTO", "rules": "QUEDA EXPRESAMENTE PROHIBIDO" }, { "title": "INTERESES MORATORIOS", "rules": "EL EQUIVALENTE A LA TASA DE INTERES INTERBANCARIA TIIE M\u00c1S 50% A RAZON DEL 5 PORCIENTO MENSUAL" }, { "title": "INCREMENTO", "rules": "EN CASO DE CONTINUAR CON EL ARRENDAMIENTO POSTERIOR A LA TERMINACI\u00d3N SUFRIRA UN INCREMENTO DE LA RENTA MENSUAL CONFORME AL INDICE NACIONAL DE PRECIOS AL CONSUMIDOR DENTRO DE LOS 12 MESES ANTERIORES A LA FECHA DLE INCREMENTO" }]
                ,
            }
        }
    },
    methods: {
        addObligation() {
            this.form.obligation.push({ title: '', rules: '' });
        },
        deleteObligation(index) {
            let vm = this;
            this.$swal({
                title: 'Eliminar obligación',
                text: 'Se eliminara el titulo de obligación',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) vm.form.obligation.splice(index, 1);
            });
        },

        addService() {
            this.form.services.push({
                service_id: '',     // si viene de catálogo
                name: '',           // si es libre
                subtotal: 0,
                date: ''            // opcional
            });
        },
        deleteService(index) {
            this.form.services.splice(index, 1);
        },

        getBankCompany() {
            let company = this.form.company_id;
            this.catalogue.getBankAccountCompany(company);
        },
        async get_department_change() {
            let id = this.form.building_id;
            await this.catalogue.get_companies_buildings(id);
        },
        get_billing_data_user() {
            let user_id = this.form.user_id;
            this.catalogue.getBillingDataUser(user_id);
        },

        closedModal() {
            this.errors = {};
            this.form = {
                id: '',
                building_id: '',
                user_id: '',
                billing_data_id: '',
                company_id: '',
                start_date: '',
                end_date: '',
                payment_period_id: '',
                currency_id: '',
                bank_account_id: '',
                forced_end_date: '',
                signed: false,
                grace_days: '',
                observations: '',
                drive: '',
                addendum: 0,
                contract_id: '',
                renew_contract_id: '',
                services: [],
                obligation: [],
            };

            // precarga servicios del catálogo como base (si quieres)
            this.catalogue.services.forEach(service => {
                this.form.services.push({
                    service_id: service.id,
                    name: service.name,
                    subtotal: 0,
                    date: ''
                });
            });

            this.send = false;
            this.load = false;
            this.$modal.hide('addNewContractBis');
        },

        async savePayTaxes() {
            const data_form = new FormData();

            data_form.append('id', this.form.id);
            data_form.append('building_id', this.form.building_id);
            data_form.append('user_id', this.form.user_id);
            data_form.append('billing_data_id', this.form.billing_data_id);
            data_form.append('company_id', this.form.company_id);
            data_form.append('start_date', this.form.start_date);
            data_form.append('end_date', this.form.end_date);
            data_form.append('payment_period_id', this.form.payment_period_id);
            data_form.append('currency_id', this.form.currency_id);
            data_form.append('bank_account_id', this.form.bank_account_id);
            data_form.append('forced_end_date', this.form.forced_end_date);
            data_form.append('signed', this.form.signed);
            data_form.append('grace_days', this.form.grace_days);
            data_form.append('observations', this.form.observations);
            data_form.append('drive', this.form.drive);
            data_form.append('obligation', JSON.stringify(this.form.obligation));
            data_form.append('addendum', this.form.addendum);
            data_form.append('contract_id', this.form.contract_id);
            data_form.append('renew_contract_id', this.form.renew_contract_id);

            data_form.append('services', JSON.stringify(this.form.services));

            let _endpoint = '/contracts_bis';
            if (this.form.id !== "") {
                data_form.append('_method', 'PUT');
                _endpoint = `/contracts_bis/${this.form.id}`;
            }

            try {
                let { data } = await request.postMedia(_endpoint, data_form);
                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-contracts_bis');
                }
            } catch (error) {
                this.errors = {};
                if (error.response) this.errors = await this.errorNotification(error);
            }
        },

        async contract(contract_id) {
            this.load = true;
            this.errors = {};
            try {
                const { data } = await request.get(`/contracts_bis/${contract_id}`);
                this.setData(data);
                this.$modal.show('addNewContractBis');
            } catch (error) {
                if (error.response) this.errors = await this.errorNotification(error);
            } finally {
                this.load = false;
            }
        },

        async setData(contract) {
            // Ojo: para no perder reactividad, asigna campo por campo
            this.form.id = contract.id || '';
            this.form.building_id = contract.building_id || '';
            this.form.company_id = contract.company_id || '';
            this.form.billing_data_id = contract.billing_data_id || '';
            this.form.user_id = contract.user_id || '';
            this.form.start_date = contract.start_date || '';
            this.form.end_date = contract.end_date || '';
            this.form.grace_days = contract.grace_days || '';
            this.form.payment_period_id = contract.payment_period_id || '';
            this.form.currency_id = contract.currency_id || '';
            this.form.bank_account_id = contract.bank_account_id || '';
            this.form.forced_end_date = contract.forced_end_date || '';
            this.form.signed = contract.signed == 1 ? true : false;
            this.form.observations = contract.observations || '';
            this.form.drive = contract.drive || '';
            this.form.addendum = contract.addendum || 0;
            this.form.contract_id = contract.contract_id || '';

            // Obligaciones
            this.form.obligation = Array.isArray(contract.obligation) ? contract.obligation : [];

            // Servicios (IMPORTANTE)
            // backend debe mandar: contract.services = [{id, service_id, name, subtotal, date}]
            this.form.services = Array.isArray(contract.services) ? contract.services.map(s => ({
                id: s.id || null,                 // para update sync
                service_id: s.service_id || '',
                name: s.service_name || s.service.name || '',
                subtotal: Number(s.subtotal || 0),
                date: s.date || ''
            })) : [];

            // Recargar catálogos dependientes para selects
            await this.get_department_change();  // carga companies_buildings
            await this.get_billing_data_user();  // carga billing_data_user
            await this.getBankCompany();         // carga bank_account_company
        },

        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },

    async mounted() {
        await this.catalogue.get_buildings();
        await this.catalogue.get_users_profiles(7);
        await this.catalogue.get_payment_periods();
        await this.catalogue.getCurrencies();
        await this.catalogue.get_services();

        // precarga servicios del catálogo (opcional)
        this.catalogue.services.forEach(service => {
            this.form.services.push({
                service_id: service.id,
                name: service.name,
                subtotal: 0,
                date: ''
            });
        });
    },

    computed: {
        ...mapGetters({ 'authUser': 'auth/user' })
    },
    created() {
        Event.$on("event-show-addNewContractBis", async (contract) => {
            // cuando viene un contrato completo o un id
            console.log('contract');
            console.log(contract);
            if (contract && contract.id) {
                await this.contract(contract.id);
            } else if (typeof contract === 'number' || typeof contract === 'string') {
                await this.contract(contract);
            } else {
                // nuevo
                this.load = false;
                this.$modal.show('addNewContractBis');
            }
        });

        Event.$on("event-show-renewContractsBis", async (contract, addendum = 0) => {
            console.log('contract bis renew');
            console.log(contract);
            console.log(addendum);

            this.load = true;
            this.errors = {};
            this.$modal.show('addNewContractBis');

            // limpiar primero
            this.form.id = '';
            this.form.building_id = contract.building_id || '';
            this.form.company_id = contract.company_id || '';
            this.form.billing_data_id = contract.billing_data_id || '';
            this.form.user_id = contract.user_id || '';
            this.form.start_date = contract.start_date || '';
            this.form.end_date = contract.end_date || '';
            this.form.grace_days = contract.grace_days || '';
            this.form.payment_period_id = contract.payment_period_id || '';
            this.form.currency_id = contract.currency_id || '';
            this.form.bank_account_id = contract.bank_account_id || '';
            this.form.forced_end_date = contract.forced_end_date || '';
            this.form.signed = contract.signed == 1 ? true : false;
            this.form.observations = contract.observations || '';
            this.form.drive = contract.drive || '';
            this.form.obligation = Array.isArray(contract.obligation) ? contract.obligation : [];
            this.form.services = Array.isArray(contract.services) ? contract.services.map(s => ({
                id: s.id || null,                 // para update sync
                service_id: s.service_id || '',
                name: s.service_name || s.service.name || '',
                subtotal: Number(s.subtotal || 0),
                date: s.date || ''
            })) : [];


            if (addendum != 0) {
                this.form.addendum = addendum;
                this.form.contract_id = contract.id;
                this.form.renew_contract_id = '';
            } else {
                this.form.addendum = 0;
                this.form.contract_id = '';
                this.form.renew_contract_id = contract.id;
            }

            this.load = false;
        });


        Event.$on("event-show-showContractIDBis", async (contract_id) => {
            await this.contract(contract_id);
        });
    },
}
</script>

<template>
    <modal name="addNewContractBis" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()">
            <i class="fa-solid fa-xmark"></i>
        </button>

        <form @submit.prevent="savePayTaxes" method="post" id="formTax" enctype="multipart/form-data">
            <div class="modal-header">
                <h5 class="modal-title">Contrato Bis - Servicios</h5>
            </div>

            <div class="modal-body">
                <div class="row" v-if="load">
                    <div class="col-md-12 text-center">
                        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><br>
                        Cargando...
                    </div>
                </div>

                <div v-else class="row">

                    <div class="col-md-4 mt-2">
                        <label>Propiedad</label>
                        <select :disabled="!prop_edit || form.id != ''" class="form-control" v-model="form.building_id"
                            @change="get_department_change()">
                            <option value="">Sin propiedad</option>
                            <option :value="building.id" v-for="(building, i) in catalogue.buildings" :key="i">
                                {{ building.name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.building_id" class="text-danger">{{ errors.building_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Usuario</label>
                        <select :disabled="!prop_edit || form.id != ''" class="form-control" v-model="form.user_id"
                            @change="get_billing_data_user()">
                            <option value="">Sin usuario</option>
                            <option :value="user.id" v-for="(user, i) in catalogue.users_profiles" :key="i">
                                {{ user.name }} {{ user.last_name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.user_id" class="text-danger">{{ errors.user_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Datos de Facturación</label>
                        <select :disabled="!prop_edit || form.id != ''" class="form-control"
                            v-model="form.billing_data_id">
                            <option value="">Sin datos de facturación</option>
                            <option v-for="(billD, i) in catalogue.billing_data_user" :value="billD.id" :key="i">
                                {{ billD.business_name }} - {{ billD.rfc }}
                            </option>
                        </select>
                        <div v-if="errors && errors.billing_data_id" class="text-danger">{{ errors.billing_data_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Empresa</label>
                        <select :disabled="!prop_edit || form.id != ''" class="form-control" v-model="form.company_id"
                            @change="getBankCompany">
                            <option value="">Sin Empresa</option>
                            <option v-for="(company, i) in catalogue.companies_buildings" :value="company.id" :key="i">
                                {{ company.name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.company_id" class="text-danger">{{ errors.company_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Fecha inicio</label>
                        <date-picker :disabled="!prop_edit || form.id != ''" valueType="format"
                            v-model="form.start_date"></date-picker>
                        <div v-if="errors && errors.start_date" class="text-danger">{{ errors.start_date[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Fecha fin</label>
                        <date-picker :disabled="!prop_edit" valueType="format" v-model="form.end_date"></date-picker>
                        <div v-if="errors && errors.end_date" class="text-danger">{{ errors.end_date[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Recurrencia</label>
                        <select :disabled="!prop_edit" class="form-control" v-model="form.payment_period_id">
                            <option value="">Sin recurrencia</option>
                            <option v-for="(p, i) in catalogue.payment_periods" :value="p.id" :key="i">{{ p.name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.payment_period_id" class="text-danger">{{
                            errors.payment_period_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Moneda</label>
                        <select :disabled="!prop_edit" class="form-control" v-model="form.currency_id">
                            <option value="">Sin moneda</option>
                            <option v-for="(c, i) in catalogue.currencies" :value="c.id" :key="i">{{ c.name }}</option>
                        </select>
                        <div v-if="errors && errors.currency_id" class="text-danger">{{ errors.currency_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Cuenta de banco</label>
                        <select class="form-control" :disabled="!prop_edit" v-model="form.bank_account_id">
                            <option value="">Selecciona una cuenta</option>
                            <option :value="bank.id" v-for="(bank, i) in catalogue.bank_account_company" :key="i">
                                <span v-if="bank.bank">{{ bank.bank.name }} | </span>{{ bank.name }} - {{ bank.number }}
                            </option>
                        </select>
                        <div v-if="errors && errors.bank_account_id" class="text-danger">{{ errors.bank_account_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Fecha fin plazo forzoso</label>
                        <date-picker :disabled="!prop_edit" valueType="format"
                            v-model="form.forced_end_date"></date-picker>
                        <div v-if="errors && errors.forced_end_date" class="text-danger">{{ errors.forced_end_date[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2 text-center">
                        <label>Contrato firmado</label>
                        <input type="checkbox" :disabled="!prop_edit" class="form-control form-control-sm"
                            v-model="form.signed">
                        <div v-if="errors && errors.signed" class="text-danger">{{ errors.signed[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Días de gracia</label>
                        <date-picker :disabled="!prop_edit" valueType="format" v-model="form.grace_days"></date-picker>
                        <div v-if="errors && errors.grace_days" class="text-danger">{{ errors.grace_days[0] }}</div>
                    </div>

                    <div class="col-md-12 mt-2">
                        <label>Observaciones</label>
                        <textarea :disabled="!prop_edit" class="form-control" v-model="form.observations"
                            rows="3"></textarea>
                        <div v-if="errors && errors.observations" class="text-danger">{{ errors.observations[0] }}</div>
                    </div>

                    <div class="col-md-12 mt-2">
                        <label>Link recursos</label>
                        <input :disabled="!prop_edit" class="form-control" v-model="form.drive">
                        <div v-if="errors && errors.drive" class="text-danger">{{ errors.drive[0] }}</div>
                    </div>

                    <!-- SERVICIOS -->
                    <div class="col-md-12 mt-3">
                        <hr>
                        <div class="d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">Servicios</h5>
                            <button v-if="prop_edit" type="button" class="btn btn-outline-success btn-sm"
                                @click="addService()">
                                <i class="fa fa-plus"></i> Agregar Servicio
                            </button>
                        </div>
                    </div>

                    <div class="col-md-12 mt-2" v-for="(service, index) in form.services" :key="'srv-' + index">
                        <div class="card bg-light">
                            <div class="card-body p-2">
                                <button v-if="prop_edit" type="button" class="btn btn-sm btn-danger float-right"
                                    @click="deleteService(index)">
                                    <i class="fa fa-trash"></i>
                                </button>

                                <div class="row">
                                    <div class="col-md-3">
                                        <label>Servicio</label>
                                        <input type="text" :disabled="!prop_edit" class="form-control"
                                            v-model="service.name" placeholder="Nombre del servicio">
                                        <div v-if="errors && errors[`services.${index}.name`]" class="text-danger">
                                            {{ errors[`services.${index}.name`][0] }}
                                        </div>
                                    </div>

                                    <div class="col-md-5">
                                        <label>Subtotal</label>
                                        <money :disabled="!prop_edit" class="form-control" v-model="service.subtotal">
                                        </money>
                                        <div v-if="errors && errors[`services.${index}.subtotal`]" class="text-danger">
                                            {{ errors[`services.${index}.subtotal`][0] }}
                                        </div>
                                    </div>

                                    <div class="col-md-3">
                                        <label>Fecha registro</label>
                                        <date-picker :disabled="!prop_edit" valueType="format"
                                            v-model="service.date"></date-picker>
                                        <div v-if="errors && errors[`services.${index}.date`]" class="text-danger">
                                            {{ errors[`services.${index}.date`][0] }}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- OBLIGACIONES -->
                    <div class="col-md-12 mt-3">
                        <hr>
                        <div class="row">
                            <div class="col-12">
                                <label>Título de obligación</label>
                                <div class="row justify-content-center mb-3" v-if="prop_edit">
                                    <div class="col-md-6">
                                        <button type="button" class="btn btn-block btn-success"
                                            @click="addObligation()">
                                            <i class="fa fa-plus"></i> Título de obligación
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6" v-for="(value, idx) in form.obligation" :key="'obl-' + idx">
                                <button class="btn btn-sm btn-danger btnDel" type="button" v-if="prop_edit"
                                    @click="deleteObligation(idx)">
                                    <i class="fa fa-trash"></i>
                                </button>

                                <div class="row divCard m-1">
                                    <div class="col-12">
                                        <label>Título:</label>
                                        <input class="form-control" :disabled="!prop_edit" v-model="value.title">
                                    </div>
                                    <div class="col-12">
                                        <label>Descripción:</label>
                                        <textarea class="form-control" :disabled="!prop_edit"
                                            v-model="value.rules"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <hr>
                            </div>
                        </div>
                    </div>

                    <!-- BOTONES -->
                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Guardar
                        </button>
                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i> Regresar
                        </button>
                    </div>

                </div>
            </div>
        </form>
    </modal>
</template>